import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { isIndexable,pageSchema } from '../../lib/pageSeo.mjs';
import routes from '../../lib/siteRoutes.json';

/** A single route manifest owns public URLs and metadata for both build HTML and navigation. */
export default function RouteSeo() {
  const { pathname } = useLocation();
  const path = pathname.replace(/\/+$/, '') || '/';
  const page = routes.find(route => route.path === path);
  useEffect(() => {
    // Replace initial-response data on client navigation without Helmet's innerHTML sink.
    document.getElementById('static-page-schema')?.remove();
    const data = pageSchema(page);
    if (!data) return;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'page-schema';
    script.appendChild(document.createTextNode(JSON.stringify(data).replace(/</g, '\\u003c')));
    document.head.appendChild(script);
    return () => script.remove();
  }, [page]);
  const canonical = `https://www.calculato.co${page?.path || path}`;
  return (
    <Helmet>
      <html lang="en" />
      <title>{page?.title || 'Calculator | Calculato'}</title>
      <meta name="description" content={page?.description || 'Free online calculator from Calculato.'} />
      <meta name="robots" content={isIndexable(page) ? 'index, follow' : 'noindex, follow'} />
      {page && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={page?.title || 'Calculato'} />
      <meta property="og:description" content={page?.description || 'Free online calculators.'} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Calculato" />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={page?.title || 'Calculato'} />
      <meta name="twitter:description" content={page?.description || 'Free online calculators.'} />
    </Helmet>
  );
}
